import {
  getPopularServices,
  getPromotionServices,
  getServices,
} from "@/services/service";
import {
  getTodaysDate
} from "@/common/helpers/DateTimeHelper.js";
import {
  formatProcessingTime
 } from "@/common/helpers/ProductHelper";

const state = {
  services: null,
  popularServices: null,
  promotionServices: null,
};

const getters = {
  services: (state) => state.services,
  popularServices: (state) => state.popularServices,
  promotionServices: (state) => state.promotionServices,
  // promotionServicesLimited, the limited mean limit to first 3 items
  promotionServicesLimited: (state) => {
    return Array.isArray(state.promotionServices) ?
      state.promotionServices.slice(0, 3) :
      [];
  },
  validService: (state) => (id) => {
    const serviceIds = new Set(state.services.map(service => service.id));
    return serviceIds.has(id);
  },
};

const actions = {
  async getServices({ commit }) {
    try {
      const response = await getServices();
      commit("getServices", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async getPopularServices({ commit }) {
    try {
      const response = await getPopularServices();
      commit("getPopularServices", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async getPromotionServices({ commit }) {
    try {
      const response = await getPromotionServices();
      commit("getPromotionServices", response.data);
    } catch (error) {
      console.log(error);
    }
  },
};

const mutations = {
  getServices(state, data) {
    //const todaysDate = getTodaysDate();

    state.services = data.map((row) => {
      /*
      if (
        !(
          row.service.startDate <= todaysDate &&
          row.service.endDate >= todaysDate
        )
      ) {
        row.promotion = false;
        // Set normal price as sell price
        row.salePrice = row.price;
        // Set original price empty
        row.originalPrice = "";
      } else if (row.service.limitQty === 0) {
        row.promotion = true;
        // Set promotionPrice as current salePrice
        row.salePrice = row.service.promotionPrice;
        // Set price as original price
        row.originalPrice = row.price;
      } else if (row.service.unitRemain > 0) {
        row.promotion = true;
        row.salePrice = row.service.promotionPrice;
        row.originalPrice = row.price;
      } else {
        row.promotion = false;
        row.salePrice = row.price;
        row.originalPrice = "";
      }
      */
      row.promotion = false;
      row.salePrice = row.price;
      row.originalPrice = "";
      row.futurePromotion = false;
      row.futureSalePrice = row.service.promotionPrice;
      row.futureOriginalPrice = row.price;
      row.service.formatProcessingTime = formatProcessingTime(row.type, row.service.processingTime);

      return row;
    });
  },
  getPopularServices(state, data) {
    //const todaysDate = getTodaysDate();

    state.popularServices = data.map((row) => {
      /*
      if (
        !(
          row.service.startDate <= todaysDate &&
          row.service.endDate >= todaysDate
        )
      ) {
        row.promotion = false;
        // Set normal price as sell price
        row.salePrice = row.price;
        // Set original price empty
        row.originalPrice = "";
      } else if (row.service.limitQty === 0) {
        row.promotion = true;
        // Set promotionPrice as current salePrice
        row.salePrice = row.service.promotionPrice;
        // Set price as original price
        row.originalPrice = row.price;
      } else if (row.service.unitRemain > 0) {
        row.promotion = true;
        row.salePrice = row.service.promotionPrice;
        row.originalPrice = row.price;
      } else {
        row.promotion = false;
        row.salePrice = row.price;
        row.originalPrice = "";
      }
      */
      row.promotion = false;
      row.salePrice = row.price;
      row.originalPrice = "";
      row.futurePromotion = false;
      row.futureSalePrice = row.service.promotionPrice;
      row.futureOriginalPrice = row.price;
      row.service.formatProcessingTime = formatProcessingTime(row.type, row.service.processingTime);

      return row;
    });
  },
  getPromotionServices(state, data) {
    const todaysDate = getTodaysDate();

    state.promotionServices = data.map((row) => {
      const validPromotionQty = row.service.limitQty === 0 || (row.service.limitQty > 0 && row.service.unitRemain > 0);

      if (
        row.service.startDate <= todaysDate &&
        row.service.endDate >= todaysDate &&
        validPromotionQty
      ) {
        row.promotion = true;
        row.salePrice = row.service.promotionPrice;
        row.originalPrice = row.price;
      } else {
        row.promotion = false;
        row.salePrice = row.price;
        row.originalPrice = "";
      }

      if (
        row.service.startDate > todaysDate &&
        row.service.endDate > todaysDate
      ) {
        row.futurePromotion = true;
        row.futureSalePrice = row.service.promotionPrice;
        row.futureOriginalPrice = row.price;
      } else {
        row.futurePromotion = false;
        row.futureSalePrice = row.service.promotionPrice;
        row.futureOriginalPrice = row.price;
      }
      row.service.formatProcessingTime = formatProcessingTime(row.type, row.service.processingTime);

      return row;
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
